import React, { Component } from 'react';
import { mapHttpToProps } from 'reducers';
import route from 'route';
import './styles.css';

import Form from 'components/Form';
const URLSearchParams = require('url-search-params');

const fields = [
	{
		key: 'nome',
		hint: 'Nome e Cognome',
		errorRequired: 'Indicare il nome del richiedente'
	},
	{
		key: 'telefono',
		hint: 'Telefono',
		rules: ['phone'],
		errorRequired: 'Indicare il telefono di contatto'
	}
];

const referenceForm = React.createRef();

class Home extends Component {
	componentDidMount() {
		window._adftrack = Array.isArray(window._adftrack)
			? window._adftrack
			: window._adftrack
				? [window._adftrack]
				: [];
		window._adftrack.push({
			pm: 307530,
			divider: encodeURIComponent('|'),
			pagename: encodeURIComponent('LEAD_DI_Segugio_STEP_1')
		});

		var s = document.createElement('script');
		s.type = 'text/javascript';
		s.async = true;
		s.src = 'https://track.adform.net/serving/scripts/trackpoint/async/';
		var x = document.getElementsByTagName('script')[0];
		x.parentNode.insertBefore(s, x);
	}

	render() {
		return (
			<div className="home">
				<Form
					ref={referenceForm}
					style={{ width: '100%', height: 'auto' }}
					fields={fields}
					onFinish={data => {
						if (!referenceForm.current.validateForm()) {
							return;
						}

						this.props.httpCall(
							'insertLead',
							{ ...data, idLanding: 27 },
							{
								then: res => {
									let j = null;
									if (res.orderID) {
										j = res.orderID;
									}
									const urlParams = new URLSearchParams(window.location.search);
									this.props.history.push(
										route('thanks') + '?i=' + urlParams.get('tduid') + '&j=' + j
									);
								},
								catch: error => {
									alert(error);
								}
							}
						);
					}}
				/>
				<p style={{ margin: 0, padding: 0, border: 0 }}>
					<img
						src="https://track.adform.net/Serving/TrackPoint/?pm=307530&ADFPageName=LEAD_DI_Segugio_STEP_1&ADFdivider=|"
						width="1"
						height="1"
						alt=""
					/>
				</p>
			</div>
		);
	}
}

export default mapHttpToProps(Home, ['insertLead']);



// WEBPACK FOOTER //
// ./src/screens/Home/index.js